import { axios } from "../../../lib/axios";

export const createIDP = (payload, orgId) => {
  return axios.post(`/auth/idp?orgId=${orgId}`, payload);
};

export const getIDPList = (orgId) => {
  return axios.get(`/auth/idp-list?orgId=${orgId}`);
};

export const deleteIDP = (providerName, orgId) => {
  return axios.delete(`/auth/idp?providerName=${providerName}&orgId=${orgId}`);
};

export const describeIDP = (providerName, orgId) => {
  return axios.get(`/auth/idp?providerName=${providerName}&orgId=${orgId}`);
};

export const editIDP = (payload, orgId) => {
  return axios.put(`/auth/idp?orgId=${orgId}`, payload);
};

export const SAMLLogin = (data) => {
  return axios.post(`/auth/admin-login-saml`, data);
};
